import { useState } from 'react'
import PropTypes from 'prop-types'
import { withLocalize } from 'react-localize-redux'
import { Modal, Button } from '@material-ui/core'
import styles from './ProjectInformation.module.scss'

const ProjectInformation = props => {
  const [open] = useState(true)

  const { hideModal, translate, project } = props
  const { OwnerId } = project || {}
  const { name, projectDescription, ProjectCustomers } = project?.Meta || {}
  const { email } = ProjectCustomers[OwnerId] || {}

  return (
    <Modal
      open={open}
      onClose={hideModal}
      arial-labelledby='simple-modal-title'
      arial-desccribedby='simple-modal-description'
    >
      <div className={styles.content}>
        <div className={styles.modalContainer}>
          <div className={styles.header}>{translate('information')}</div>
          <div className={styles.projectName}>
            {translate('name') + ':'}
            <p>{name}</p>
          </div>
          <div className={styles.projectOwner}>
            {translate('owner') + ':'}
            <p>{email}</p>
          </div>
          {projectDescription && (
            <div className={styles.projectDescription}>
              {translate('description') + ':'}
              <p className={styles.projectDescriptionValue}>{projectDescription}</p>
            </div>
          )}
          <div className={styles.footer}>
            <Button
              fullWidth
              variant='contained'
              className={styles.buttonCancelar}
              onClick={hideModal}
            >
              {translate('close')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

ProjectInformation.propTypes = {
  hideModal: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired
}

export default withLocalize(ProjectInformation)
